import { Link } from 'react-router-dom';
import { dailyContestArticles } from '@/mocks/home';

export default function DailyHighlights() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider font-heading">
              51爆料精选
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-2">
              今日猛料
              <span className="block italic font-serif text-primary-500">不容错过</span>
            </h2>
          </div>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {dailyContestArticles.map((article, index) => {
            const bgColors = ['bg-primary-100/60', 'bg-accent-100/60', 'bg-secondary-100/60', 'bg-primary-100/50'];
            return (
              <Link
                key={article.id}
                to="/category/all"
                className="group rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
              >
                <div className={`${bgColors[index % 4]} rounded-2xl overflow-hidden`}>
                  <div className="relative h-[220px] md:h-[260px] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    {article.isHot && (
                      <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-semibold rounded-full">
                        热门
                      </span>
                    )}
                  </div>
                  <div className="p-4 bg-background-50">
                    <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-2">
                      {new Date(article.publishedAt).toLocaleDateString('zh-CN', {
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}